import React from 'react';

interface PalletProps {
  palletNo: number;
  containerWidth: number;
  containerLength: number;
}

const PalletPlanning: React.FC<PalletProps> = ({
  palletNo,
  containerWidth,
  containerLength,
}) => {
  const layer = containerLength * containerWidth; // pallets per layer

  // Which layer are we in?
  const layerIndex = Math.floor(palletNo / layer);
  const palletIndex = palletNo % layer;

  // Base positions for pallets
  let x: number = 315 + (palletIndex * -65);
  let y: number = 75 + (palletIndex * 38);

  // If pallet index overflows one row, adjust
  if (palletIndex >= containerLength) {
    x = 390 + ((palletIndex - containerLength) * -65);
    y = 120 + ((palletIndex - containerLength) * 38);
  }

  // Apply layer offset in Y (stack upwards)
  y -= layerIndex * 50; // adjust spacing per layer as needed

  return (
    <g transform={`scale(0.5), translate(${x},${y})`}>
      <polygon
        points="50,100 100,130 100,190 50,160"
        fill="#D9B382"
        stroke="#000000"
        strokeWidth="1"
      />
      <polygon
        points="100,130 150,100 150,160 100,190"
        fill="#C69C6D"
        stroke="#000000"
        strokeWidth="1"
      />
      <polygon
        points="50,100 100,70 150,100 100,130"
        fill="#E7C9A9"
        stroke="#000000"
        strokeWidth="1"
      />
    </g>
  );
};

export default PalletPlanning;
